var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#file_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0245A3",
    d: "M16.667 20.667h4.666V22h-4.666v4.667h-1.334V22h-4.667v-1.333h4.667V16h1.333zM29.333 9.724V32H2.667V3.333A3.34 3.34 0 0 1 6 0h13.61zM20 9.334h7.057L20 2.275zm8 21.333v-20h-9.333V1.333H6c-1.103 0-2 .898-2 2v27.334z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "file_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgFile;